// Check if the device supports touch (does not support mouse events)
export const deviceSupportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
